import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { MsisdnService } from '../msisdn.service';
import { Msisdn } from '../msisdns';

@Component({
  selector: 'cc-msisdn-list',
  templateUrl: './msisdn-list.component.html',
  styleUrls: ['./msisdn-list.component.scss']
})
export class MsisdnListComponent implements OnInit, OnChanges {
  @Input() msisdns: string[] = [];
  public formattedMsisdns: Msisdn[];

  constructor(public msisdnService: MsisdnService) {}

  ngOnInit() {
    this.fetchMsisdns();
  }

  ngOnChanges() {
    this.fetchMsisdns();
  }

  fetchMsisdns() {
    this.msisdnService.msisdns().subscribe(items => {
      this.formattedMsisdns = items.filter(item => this.msisdns.includes(item.msisdn));
    });
  }
}
